import { Link, useLocation } from 'react-router'

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import { Skeleton } from '@/components/ui/skeleton'
import { useProject } from '@/contexts/project'
import useTranslator from '@/hooks/translation'
import { useQueryParams } from '@/hooks/use-query-params'

export const ProjectBreadcrumbs = () => {
  const location = useLocation()
  const { getTranslation } = useTranslator()

  const { getQueryParams } = useQueryParams()

  const { project } = useProject()

  const { companyId } = getQueryParams()
  const pathname = location.pathname

  const getPageLabel = (): string => {
    if (pathname.includes('/settings')) {
      return getTranslation('projects.settings')
    }

    if (pathname.includes('/bots')) {
      return getTranslation('common.bots')
    }

    return ''
  }

  const pageLabel = getPageLabel()

  if (!pageLabel) return null

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to={`/companies/${companyId}/projects`}>
              {getTranslation('common.projects')}
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />

        <BreadcrumbItem>
          {project ? project.name : <Skeleton className="h-4 w-24" />}
        </BreadcrumbItem>
        <BreadcrumbSeparator />

        <BreadcrumbItem>
          <BreadcrumbPage>{pageLabel}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  )
}
